"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareInputArg = void 0;
const ethers_1 = require("ethers");
const common_1 = require("../../common");
function prepareInputArg(type, arg) {
    let result = arg;
    switch (type) {
        case 'address':
            result = common_1.prepareAddress(arg, true);
            break;
        case 'bytes':
            result = arg || '0x';
            break;
        default:
            if (!type.endsWith(']')) {
                if (type.startsWith('uint')) {
                    result = ethers_1.BigNumber.from(arg || 0).toHexString();
                }
            }
    }
    return result;
}
exports.prepareInputArg = prepareInputArg;
